import { ApiRequest } from "src/helpers";
import { API_END_POINTS } from "src/constants";

export function deleteLeadApi(id) {
  return ApiRequest.fetchAdmin({
    method: "delete",
    url: `${API_END_POINTS.DELETE_LEAD}/${id}`,
  }).then((response) => response.data.lead);
}